<template>
  <v-app>
    <v-app-bar
        app
        color="light-blue accent-2"
        elevation="4"
        class="text--center subtitle-2"
        dark
    >
      <div class="d-flex align-center">
        <h1>Отчет по нарушениям </h1>
      </div>
    </v-app-bar>

    <v-main>
      <v-container fluid>
        <v-form>
          <v-form class="ma-6 pa-0">
            <v-btn
                color="light-blue accent-2"
                class="button rounded-md white--text"
                @click="getReport"
                :disabled="loading"
                x-large
            >
              сформировать
            </v-btn>
          </v-form>
        </v-form>

        <v-row>
          <v-col>
            <v-simple-table dense>
              <template v-slot:default>
                <thead>
                <tr>
                  <th class="text-left" v-for="item in headers"
                      :key="item">{{ item }}
                  </th>
                </tr>
                </thead>
                <tbody>
                <template v-for="item in report">
                  <tr :key="item.id">
                    <td></td>
                    <td>{{ item.id }}</td>
                    <td v-if="item.data.length > 0">
                      <v-btn
                          class="mx-2"
                          fab
                          small
                          text
                          @click="item.menu = true"
                          v-if="item.menu === false"
                      >
                        <v-icon dark>
                          mdi-plus
                        </v-icon>
                      </v-btn>
                      <v-btn
                          class="mx-2"
                          fab
                          small
                          text
                          @click="item.menu = false"
                          v-if="item.menu === true"
                      >
                        <v-icon dark>
                          mdi-minus
                        </v-icon>
                      </v-btn>
                      {{ item.department }}
                    </td>
                    <td v-else>{{ item.department }}</td>
                    <td>{{ item.countProcess }}</td>
                    <td>{{ item.dateStart }}</td>
                    <td>{{ item.agreesDay }}</td>
                  </tr>
                  <template v-if="item.menu">
                    <template v-for="elem in item.data">
                      <tr :key="item.id+'/'+elem.id">
                        <td>
                          <v-btn
                              class="mx-2"
                              fab
                              small
                              text
                              @click="openLink(elem.link)"
                          >
                            <v-icon dark>
                              mdi-application-import
                            </v-icon>
                          </v-btn>
                        </td>
                        <td>{{ elem.id }}</td>
                        <td>{{ elem.department }}</td>
                        <td>{{ elem.countProcess }}</td>
                        <td>{{ elem.dateStart }}</td>
                        <td>{{ elem.agreesDay }}</td>
                      </tr>
                    </template>
                  </template>
                </template>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import axios from 'axios'

export default {
  name: 'App',
  data: () => ({
    loading: false,
    employee: [],
    selectEmployee: '',
    dates: [],
    normalDate: [],
    menu: false,
    headers: [
      '',
      'ID процесса',
      'Этап согласования',
      'Кол-во процессов',
      'Дата перехода в отдел',
      'Дней(часов) сколько находиться процесс на согласовании в отделе'
    ],
    report: [
      {
        id: 1,
        department: 'Непосредственный руководитель',
        data: [],
        agreesDay: '',
        agreesD: 0,
        agreesH: 0,
        countProcess: 0,
        menu: false
      },
      {
        id: 2,
        department: 'Доп.согласующие',
        data: [],
        agreesDay: '',
        agreesD: 0,
        agreesH: 0,
        countProcess: 0,
        menu: false
      },
      {
        id: 3,
        department: 'Отдел эксплуатации',
        data: [],
        agreesDay: '',
        agreesD: 0,
        agreesH: 0,
        countProcess: 0,
        menu: false
      },
      {
        id: 4,
        department: 'Строительный департамент',
        data: [],
        agreesDay: '',
        agreesD: 0,
        agreesH: 0,
        countProcess: 0,
        menu: false
      },
      {id: 5, department: 'Юр. отдел', data: [], agreesDay: '', agreesD: 0, agreesH: 0, countProcess: 0, menu: false},
      {
        id: 6,
        department: 'Бухгалтерерия',
        data: [],
        agreesDay: '',
        agreesD: 0,
        agreesH: 0,
        countProcess: 0,
        menu: false
      },
      {
        id: 7,
        department: 'Финансовый директор',
        data: [],
        agreesDay: '',
        agreesD: 0,
        agreesH: 0,
        countProcess: 0,
        menu: false
      },
      {
        id: 8,
        department: 'Зам. генерального директора',
        data: [],
        agreesDay: '',
        agreesD: 0,
        agreesH: 0,
        countProcess: 0,
        menu: false
      },
      {
        id: 9,
        department: 'Генеральный директор',
        data: [],
        agreesDay: '',
        agreesD: 0,
        agreesH: 0, countProcess: 0, menu: false
      },
    ],
    url: 'https://rusagromarket.bitrix24.ru/rest/223/se12af78b6ze7sqw/',
  }),
  methods: {
    openLink(link) {
      window.open(link, '_blank')
    },
    exportXLS() {
      console.log('exportXLS')
    },
    async normalizeDate(dates) {
      try {
        this.normalDate = []
        const firstDate = dates[0].split('-')
        const twoDate = dates[1].split('-')
        const firstDateFormated = firstDate[2] + '.' + firstDate[1] + '.' + firstDate[0] + ' 00:00:00'
        const twoDateFormated = twoDate[2] + '.' + twoDate[1] + '.' + twoDate[0] + ' 23:59:59'
        this.normalDate.push(firstDateFormated)
        this.normalDate.push(twoDateFormated)
        console.log(this.normalDate)
      } catch (e) {
        console.log(e)
      }
    },
    async getReport() {
      try {
        this.report = [
          {
            id: 1,
            department: 'Непосредственный руководитель',
            data: [],
            agreesDay: '',
            agreesD: 0,
            agreesH: 0,
            countProcess: 0,
            menu: false
          },
          {
            id: 2,
            department: 'Доп.согласующие',
            data: [],
            agreesDay: '',
            agreesD: 0,
            agreesH: 0,
            countProcess: 0,
            menu: false
          },
          {
            id: 3,
            department: 'Отдел эксплуатации',
            data: [],
            agreesDay: '',
            agreesD: 0,
            agreesH: 0,
            countProcess: 0,
            menu: false
          },
          {
            id: 4,
            department: 'Строительный департамент',
            data: [],
            agreesDay: '',
            agreesD: 0,
            agreesH: 0,
            countProcess: 0,
            menu: false
          },
          {
            id: 5,
            department: 'Юр. отдел',
            data: [],
            agreesDay: '',
            agreesD: 0,
            agreesH: 0,
            countProcess: 0,
            menu: false
          },
          {
            id: 6,
            department: 'Бухгалтерерия',
            data: [],
            agreesDay: '',
            agreesD: 0,
            agreesH: 0,
            countProcess: 0,
            menu: false
          },
          {
            id: 7,
            department: 'Финансовый директор',
            data: [],
            agreesDay: '',
            agreesD: 0,
            agreesH: 0,
            countProcess: 0,
            menu: false
          },
          {
            id: 8,
            department: 'Зам. генерального директора',
            data: [],
            agreesDay: '',
            agreesD: 0,
            agreesH: 0,
            countProcess: 0,
            menu: false
          },
          {
            id: 9,
            department: 'Генеральный директор',
            data: [],
            agreesDay: '',
            agreesD: 0,
            agreesH: 0, countProcess: 0, menu: false
          },
        ]
        const reportData = []
        //await this.normalizeDate(this.dates)
        const params = {
          IBLOCK_TYPE_ID: 'bitrix_processes',
          IBLOCK_ID: '35',
          FILTER: {
            PROPERTY_167: 109,
            '>=DATE_CREATE': '01.08.2022 00:00:00',
            // '<=DATE_CREATE': this.normalDate[1],
          }
        }
        const method = 'lists.element.get'
        let i = 1
        let next = 0
        while (i > 0) {
          params.start = next
          const objData = await axios.post(this.url + method, params)
          next = objData.data.next
          for (const elem of objData.data.result) {
            //reportData.push(elem)
            if (!elem.PROPERTY_149) {
              reportData.push(elem)
            }
          }
          if (!next) {
            i = 0
          }
        }
        for (const elem of reportData) {
          let dataStart = ''
          let dataEnd = ''
          const logData = elem.DETAIL_TEXT.split('\n')
          const filterLogData = logData.filter(e => {
            if (e) {
              return e
            }
          })
          const departIndex = {
            0: ['Непосредственный руководитель', 'PROPERTY_169', 'PROPERTY_171'],
            1: ['Доп.согласующие', 'PROPERTY_211', 'PROPERTY_209'],
            2: ['Отдел эксплуатации', 'PROPERTY_1169', 'PROPERTY_1171'],
            3: ['Строительный департамент', 'PROPERTY_1173', 'PROPERTY_1175'],
            4: ['Юр. отдел', 'PROPERTY_159', 'PROPERTY_161'],
            5: ['Бухгалтерерия', 'PROPERTY_155', 'PROPERTY_157'],
            6: ['Финансовый директор', 'PROPERTY_1191', 'PROPERTY_1189'],
            7: ['Зам. генерального директора', 'PROPERTY_151', 'PROPERTY_153'],
            8: ['Генеральный директор', 'PROPERTY_149', 'PROPERTY_163'],
          }
          for (const element of filterLogData) {
            if (element.includes('согласовывает руководитель инициатора')) {
              if (!elem.PROPERTY_169) {
                let date = new Date();
                dataStart = element.split(' ')[0]
                dataEnd = elem.PROPERTY_169 ? Object.values(elem.PROPERTY_169)[0] : ''
                const newDateStartData = dataStart.split('.')
                const newDateStart = new Date(`${newDateStartData[2]}-${newDateStartData[1]}-${newDateStartData[0]}T00:00:00`)
                const timeDiff = Math.abs(date.getTime() - newDateStart.getTime());
                const hoursDiff = Math.round(timeDiff / (1000 * 3600));
                const diffDays = Math.round(timeDiff / (1000 * 3600 * 24));
                const reportItem = {
                  id: elem.ID,
                  department: departIndex[0][0],
                  dateStart: dataStart,
                  dateAgrees: dataEnd,
                  agreesDay: `${diffDays}(${hoursDiff})`,
                  link: `https://rusagromarket.bitrix24.ru/bizproc/processes/35/element/0/${elem.ID}/?list_section_id=`
                }
                this.report[0].data.push(reportItem)
                this.report[0].countProcess += 1
              }
            }
            if (element.includes('Согласовывает зам.Директора')) {
              if (!elem.PROPERTY_151) {
                let date = new Date();
                dataStart = element.split(' ')[0]
                dataEnd = elem.PROPERTY_151 ? Object.values(elem.PROPERTY_151)[0] : ''
                const newDateStartData = dataStart.split('.')
                const newDateStart = new Date(`${newDateStartData[2]}-${newDateStartData[1]}-${newDateStartData[0]}T00:00:00`)
                const timeDiff = Math.abs(date.getTime() - newDateStart.getTime());
                const hoursDiff = Math.round(timeDiff / (1000 * 3600));
                const diffDays = Math.round(timeDiff / (1000 * 3600 * 24));
                const reportItem = {
                  id: elem.ID,
                  department: departIndex[7][0],
                  dateStart: dataStart,
                  dateAgrees: dataEnd,
                  agreesDay: `${diffDays}(${hoursDiff})`,
                  link: `https://rusagromarket.bitrix24.ru/bizproc/processes/35/element/0/${elem.ID}/?list_section_id=`
                }
                this.report[7].data.push(reportItem)
                this.report[7].countProcess += 1
              }
            }
            if (element.includes('Согласовывает отдел бухгалтерии')) {
              if (!elem.PROPERTY_155) {
                let date = new Date();
                dataStart = element.split(' ')[0]
                dataEnd = elem.PROPERTY_155 ? Object.values(elem.PROPERTY_155)[0] : ''
                const newDateStartData = dataStart.split('.')
                const newDateStart = new Date(`${newDateStartData[2]}-${newDateStartData[1]}-${newDateStartData[0]}T00:00:00`)
                const timeDiff = Math.abs(date.getTime() - newDateStart.getTime());
                const hoursDiff = Math.round(timeDiff / (1000 * 3600));
                const diffDays = Math.round(timeDiff / (1000 * 3600 * 24));
                const reportItem = {
                  id: elem.ID,
                  department: departIndex[5][0],
                  dateStart: dataStart,
                  dateAgrees: dataEnd,
                  agreesDay: `${diffDays}(${hoursDiff})`,
                  link: `https://rusagromarket.bitrix24.ru/bizproc/processes/35/element/0/${elem.ID}/?list_section_id=`
                }
                this.report[5].data.push(reportItem)
                this.report[5].countProcess += 1
              }
            }
            if (element.includes('Согласовывает юридический')) {
              if (!elem.PROPERTY_159) {
                let date = new Date();
                dataStart = element.split(' ')[0]
                dataEnd = elem.PROPERTY_159 ? Object.values(elem.PROPERTY_159)[0] : ''
                const newDateStartData = dataStart.split('.')
                const newDateStart = new Date(`${newDateStartData[2]}-${newDateStartData[1]}-${newDateStartData[0]}T00:00:00`)
                const timeDiff = Math.abs(date.getTime() - newDateStart.getTime());
                const hoursDiff = Math.round(timeDiff / (1000 * 3600));
                const diffDays = Math.round(timeDiff / (1000 * 3600 * 24));
                const reportItem = {
                  id: elem.ID,
                  department: departIndex[4][0],
                  dateStart: dataStart,
                  dateAgrees: dataEnd,
                  agreesDay: `${diffDays}(${hoursDiff})`,
                  link: `https://rusagromarket.bitrix24.ru/bizproc/processes/35/element/0/${elem.ID}/?list_section_id=`
                }
                this.report[4].data.push(reportItem)
                this.report[4].countProcess += 1
              }
            }
            if (element.includes('Согласовывает ген. директор')) {
              if (!elem.PROPERTY_149) {
                let date = new Date();
                dataStart = element.split(' ')[0]
                dataEnd = elem.PROPERTY_149 ? Object.values(elem.PROPERTY_149)[0] : ''
                const newDateStartData = dataStart.split('.')
                const newDateStart = new Date(`${newDateStartData[2]}-${newDateStartData[1]}-${newDateStartData[0]}T00:00:00`)
                const timeDiff = Math.abs(date.getTime() - newDateStart.getTime());
                const hoursDiff = Math.round(timeDiff / (1000 * 3600));
                const diffDays = Math.round(timeDiff / (1000 * 3600 * 24));
                const reportItem = {
                  id: elem.ID,
                  department: departIndex[8][0],
                  dateStart: dataStart,
                  dateAgrees: dataEnd,
                  agreesDay: `${diffDays}(${hoursDiff})`,
                  link: `https://rusagromarket.bitrix24.ru/bizproc/processes/35/element/0/${elem.ID}/?list_section_id=`
                }
                this.report[8].data.push(reportItem)
                this.report[8].countProcess += 1
              }
            }
            if (element.includes('Согласовывает Отдел эксплуатации')) {
              if (!elem.PROPERTY_1169) {
                let date = new Date();
                dataStart = element.split(' ')[0]
                dataEnd = elem.PROPERTY_1169 ? Object.values(elem.PROPERTY_1169)[0] : ''
                const newDateStartData = dataStart.split('.')
                const newDateStart = new Date(`${newDateStartData[2]}-${newDateStartData[1]}-${newDateStartData[0]}T00:00:00`)
                const timeDiff = Math.abs(date.getTime() - newDateStart.getTime());
                const hoursDiff = Math.round(timeDiff / (1000 * 3600));
                const diffDays = Math.round(timeDiff / (1000 * 3600 * 24));
                const reportItem = {
                  id: elem.ID,
                  department: departIndex[2][0],
                  dateStart: dataStart,
                  dateAgrees: dataEnd,
                  agreesDay: `${diffDays}(${hoursDiff})`,
                  link: `https://rusagromarket.bitrix24.ru/bizproc/processes/35/element/0/${elem.ID}/?list_section_id=`
                }
                this.report[2].data.push(reportItem)
                this.report[2].countProcess += 1
              }
            }
            if (element.includes('Согласовывает Отдел стройки')) {
              if (!elem.PROPERTY_1173) {
                let date = new Date();
                dataStart = element.split(' ')[0]
                dataEnd = elem.PROPERTY_1173 ? Object.values(elem.PROPERTY_1173)[0] : ''
                const newDateStartData = dataStart.split('.')
                const newDateStart = new Date(`${newDateStartData[2]}-${newDateStartData[1]}-${newDateStartData[0]}T00:00:00`)
                const timeDiff = Math.abs(date.getTime() - newDateStart.getTime());
                const hoursDiff = Math.round(timeDiff / (1000 * 3600));
                const diffDays = Math.round(timeDiff / (1000 * 3600 * 24));
                const reportItem = {
                  id: elem.ID,
                  department: departIndex[3][0],
                  dateStart: dataStart,
                  dateAgrees: dataEnd,
                  agreesDay: `${diffDays}(${hoursDiff})`,
                  link: `https://rusagromarket.bitrix24.ru/bizproc/processes/35/element/0/${elem.ID}/?list_section_id=`
                }
                this.report[3].data.push(reportItem)
                this.report[3].countProcess += 1
              }
            }
            if (element.includes('Согласовывает фин.директор')) {
              if (!elem.PROPERTY_1191) {
                let date = new Date();
                dataStart = element.split(' ')[0]
                dataEnd = elem.PROPERTY_1191 ? Object.values(elem.PROPERTY_1191)[0] : ''
                const newDateStartData = dataStart.split('.')
                const newDateStart = new Date(`${newDateStartData[2]}-${newDateStartData[1]}-${newDateStartData[0]}T00:00:00`)
                const timeDiff = Math.abs(date.getTime() - newDateStart.getTime());
                const hoursDiff = Math.round(timeDiff / (1000 * 3600));
                const diffDays = Math.round(timeDiff / (1000 * 3600 * 24));
                const reportItem = {
                  id: elem.ID,
                  department: departIndex[6][0],
                  dateStart: dataStart,
                  dateAgrees: dataEnd,
                  agreesDay: `${diffDays}(${hoursDiff})`,
                  link: `https://rusagromarket.bitrix24.ru/bizproc/processes/35/element/0/${elem.ID}/?list_section_id=`
                }
                this.report[6].data.push(reportItem)
                this.report[6].countProcess += 1
              }
            }
            if (element.includes('Согласовывают доп.согласующие, указанные инициатором')) {
              if (!elem.PROPERTY_211) {
                let date = new Date();
                dataStart = element.split(' ')[0]
                dataEnd = elem.PROPERTY_211 ? Object.values(elem.PROPERTY_211)[0] : ''
                const newDateStartData = dataStart.split('.')
                const newDateStart = new Date(`${newDateStartData[2]}-${newDateStartData[1]}-${newDateStartData[0]}T00:00:00`)
                const timeDiff = Math.abs(date.getTime() - newDateStart.getTime());
                const hoursDiff = Math.round(timeDiff / (1000 * 3600));
                const diffDays = Math.round(timeDiff / (1000 * 3600 * 24));
                const reportItem = {
                  id: elem.ID,
                  department: departIndex[1][0],
                  dateStart: dataStart,
                  dateAgrees: dataEnd,
                  agreesDay: `${diffDays}(${hoursDiff})`,
                  link: `https://rusagromarket.bitrix24.ru/bizproc/processes/35/element/0/${elem.ID}/?list_section_id=`
                }
                this.report[1].data.push(reportItem)
                this.report[1].countProcess += 1
              }
            }
          }
        }
        console.log(this.report, 'report')
      } catch (e) {
        console.log(e)
      }
    },
  },
}
</script>
